var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "appointment-missed-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M14.625,0a14.625,14.625,0,0,0,0,29.25c.387,0,.747-.044,1.125-.07v-4.57a9.6,9.6,0,0,1-1.125.141A10.125,10.125,0,1,1,24.75,14.625a9.6,9.6,0,0,1-.141,1.125h4.57c.026-.378.07-.738.07-1.125A14.659,14.659,0,0,0,14.625,0Zm0,6.75A1.122,1.122,0,0,0,13.5,7.875V13.5H10.125a1.125,1.125,0,1,0,0,2.25h4.5a1.122,1.122,0,0,0,1.125-1.125V7.875A1.122,1.122,0,0,0,14.625,6.75Zm0,0",
    fill: "#081831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M16.358,8.025a9,9,0,1,0,7,2.61A8.969,8.969,0,0,0,16.358,8.025Zm-2.54,3.533a2.26,2.26,0,0,1,1.591.668L17,13.817l1.591-1.591a2.25,2.25,0,1,1,3.182,3.182L20.182,17l1.591,1.591a2.25,2.25,0,0,1-3.182,3.182L17,20.181l-1.591,1.591a2.25,2.25,0,0,1-3.182-3.182L13.818,17l-1.591-1.591a2.259,2.259,0,0,1,1.591-3.85Zm0,0",
    transform: "translate(10 10.001)",
    fill: "#d9152d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAppointmentIcon);
export default __webpack_public_path__ + "static/media/cancelAppointmentIcon.8a292d514ca92f11129b8b4855776ff5.svg";
export { ForwardRef as ReactComponent };